import { Placeholder } from "react-bootstrap";

const MenuListSkeleton = () => (
    <div className="scroll-container">
        <div className="menu-list-scrollable" style={{ display: 'flex', gap: '1rem' }}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="menu_card" style={{ width: '200px', padding: '1rem' }}>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={12} style={{ height: '20px' }} />
                        <Placeholder xs={8} style={{ height: '15px' }} className="mt-2" />
                        <Placeholder xs={6} style={{ height: '15px' }} className="mt-1" />
                    </Placeholder>
                </div>
            ))}
        </div>
    </div>
);

export default MenuListSkeleton;